module.exports = __webpack_public_path__ + "fonts/effect-bane-of-hells-kitchen-fe49cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-bane-of-hells-kitchen.svg
// module id = 712
// module chunks = 0